import React, {Component} from 'react';
import TooieModal from "./common/TooieModal.react.js";

let i18n = require("i18next");

export default class PrinterStatusModal extends Component {
    render() {
        const msgStyle = {
            margin: "0 auto", width: "80%", lineHeight: "25px", marginTop: 30,
            marginBottom: 30, textAlign: "center", fontSize: 24
        };

        return <TooieModal id="printerStatusModal" title={i18n.t("pos.printer.status")}>
            <div className="printers-container sub-container hidden">
                <ul className="printers list-group">
                </ul>
            </div>
            <div className="unconfig">
                <p style={msgStyle}>{i18n.t("pos.printer.unconfig")}</p>
            </div>
            <div className="printer-offline">
                <p style={msgStyle}>{i18n.t("pos.printer.offline")}</p>
            </div>
            <div className="printer-btns">
                <button className="clearQueueBtn btn btn-primary">{i18n.t("pos.printer.queue.clear")}</button>
            </div>
        </TooieModal>;
    }
}


// WEBPACK FOOTER //
// ./src/react/PrinterStatusModal.react.js